import React, {Fragment} from "react";
import AddGroup from "../../../components/Modal/AddGroup";
import ListView from "../../../components/ContentDisplay/ListView";
import DeleteModal from "../../../components/Modal/DeleteModal";
import {GroupCard} from "./groupCard";
import {ACTION_LIST, LIST_HEADERS, PERMS_FOR_ACTIONS} from "./groupsTable.constants";
import {useGroupTableActions} from "./useGroupTableActions";
import {useGroupsTableData} from "./useGroupsTableData";
import {useGroupsTableSearchOptions} from "./useGroupsSearchOptions";

const GroupsTable = () => {
  const {fetchAfterDelete, groups, handleSearch, paginationConfig, totalCount} =
    useGroupsTableData();
  const {
    deleteGroup,
    deleteModalStatus,
    editModalStatus,
    handleActionSelection,
    setDeleteModalStatus,
    setEditModalStatus,
  } = useGroupTableActions(fetchAfterDelete);
  const {searchOptions} = useGroupsTableSearchOptions();

  return (
    <Fragment>
      {deleteModalStatus && (
        <DeleteModal
          header={"Delete Group"}
          modalBody={"Are you sure you want to delete this group ?"}
          onClose={() => setDeleteModalStatus(false)}
          onDelete={deleteGroup}
          open={deleteModalStatus}
        />
      )}
      {editModalStatus && (
        <AddGroup open={editModalStatus} onClose={() => setEditModalStatus(false)} />
      )}
      <ListView
        cardContent={GroupCard}
        listItems={groups}
        listHeaders={LIST_HEADERS}
        onSelectAction={handleActionSelection}
        withActions
        actionsList={ACTION_LIST}
        permsForActions={PERMS_FOR_ACTIONS}
        totalCount={totalCount}
        withPagination={paginationConfig}
        withSearchQuery={true}
        searchPlaceHolder={"Filter Groups"}
        searchOptions={searchOptions}
        handleSearch={handleSearch}
      />
    </Fragment>
  );
};

export default GroupsTable;
